import decode from "jwt-decode";
import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";
import i18n from "../../utils/LanguageSelector/i18n";

export const validateInput = (id, value) => {
  const validEmailRegex = RegExp(
    // eslint-disable-next-line no-useless-escape
    /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i
  );
  const validPassword = RegExp(/^(?=.*[A-Z])+(?=.*[a-z])+(?=.*[0-9])/);
  const validUppercase = RegExp(/^(?=.*[A-Z])/);
  const validLowercase = RegExp(/^(?=.*[a-z])/);
  const validNumber = RegExp(/^(?=.*[0-9])/);
  let errors = {};

  switch (id) {
    case "email":
      errors.email = validEmailRegex.test(value)
        ? ""
        : i18n.t("signin.invalidemail");
      break;

    case "password":
      if (validPassword.test(value)) {
        errors.password = "";
      }
      if (!validNumber.test(value)) {
        errors.password = i18n.t("signin.pwerror1");
      }
      if (!validUppercase.test(value)) {
        errors.password = i18n.t("signin.pwerror2");
      }
      if (!validLowercase.test(value)) {
        errors.password = i18n.t("signin.pwerror3");
      }
      if (value.length < 8) {
        errors.password = i18n.t("signin.pwerror4");
      }
      break;
    default:
      break;
  }
  return errors;
};

export const authUser = (JWT) => {
  if (!JWT /* || !refreshJWT */) {
    return false;
  }
  try {
    const { exp } = decode(JWT);
    if (exp < new Date().getTime() / 1000) {
      return false;
    }
  } catch (e) {
    return false;
  }
  return true;
};

export const authAdmin = (JWT) => {
  if (!JWT /* || !refreshJWT */) {
    return false;
  } else {
    const { role } = decode(JWT);
    return authUser(JWT) && role === "admin" ? true : false;
  }
};

export const checkFilled = (obj, fields) => {
  let filled = true;
  fields.forEach((item) => {
    if (obj[item.id].length === 0) {
      filled = false;
    }
  });
  return filled;
};

export const setLoginError = (response) => {
  let message = "";
  switch (response) {
    case "bad username":
      message = i18n.t("signin.emailerror1");
      break;
    case "user not confirmed":
      message = i18n.t("signin.emailerror2");
      break;
    case "passwords do not match":
      message = i18n.t("signin.emailerror3");
      break;
    default:
      message = i18n.t("signin.emailerrorgeneral");
  }
  return message;
};

export const validateAddress = (address) => {
  let validated = true;
  console.log(address);
  if (
    address &&
    Object.keys(address).length === 0 &&
    address.constructor === Object
  ) {
    validated = false;
  } else {
    for (let i in address) {
      console.log(address[i]);
      if (address[i].length === 0) {
        validated = false;
      }
    }
  }
  console.log(validated);
  return validated;
};

export const checkAddress = (transfer, airport, address) => {
  if (
    (!transfer && airport === "" && !validateAddress(address)) ||
    (!transfer && airport === null && !validateAddress(address))
  ) {
    return false;
  } else return true;
};

export const fillForm = (place) => {
  let tempAddress = { city: "", address: "", postcode: "", country: "" };
  if (place.address_components !== undefined) {
    tempAddress.companyname = place.name;
    for (const component of place.address_components) {
      const componentType = component.types[0];
      switch (componentType) {
        case "street_number": {
          tempAddress.address = `${component.long_name} ${tempAddress.address}`;
          break;
        }
        case "route": {
          tempAddress.address = `${component.short_name} ${tempAddress.address}`;
          break;
        }
        case "postal_code": {
          tempAddress.postcode = `${component.long_name}`;
          break;
        }
        case "locality":
          tempAddress.city = component.long_name;
          break;
        case "sublocality_level_1":
          tempAddress.address = `${component.long_name} ${tempAddress.address}`;
          break;
        case "sublocality_level_2":
          tempAddress.address = `${component.long_name} ${tempAddress.address}`;
          break;
        case "administrative_area_level_1":
          tempAddress.address = `${component.long_name} ${tempAddress.address}`;
          break;
        case "administrative_area_level_2":
          tempAddress.address = `${component.long_name} ${tempAddress.address}`;
          tempAddress.city = component.long_name;
          break;
        case "administrative_area_level_3":
          tempAddress.address = `${component.long_name} ${tempAddress.address}`;
          break;
        case "country":
          tempAddress.country = component.long_name;
          break;
        default:
          console.log(componentType, "Not part of address");
      }
    }
  }
  return tempAddress;
};

export const downloadPDF = (id) => {
  const input = document.getElementById("divToPrint");
  html2canvas(input, { scale: "2" }).then((canvas) => {
    let imgData = canvas.toDataURL("image/jpeg", 0.3);
    let imgWidth = 210;
    let pageHeight = 300;
    let imgHeight = (canvas.height * imgWidth) / canvas.width;
    let heightLeft = imgHeight;
    let doc = new jsPDF({ format: "a4" });
    let position = 0;
    doc.addImage(
      imgData,
      "JPEG",
      0,
      position,
      imgWidth,
      imgHeight,
      undefined,
      "FAST"
    );
    heightLeft -= pageHeight;
    while (heightLeft >= 0) {
      position = heightLeft - imgHeight;
      doc.addPage();
      doc.addImage(
        imgData,
        "JPEG",
        0,
        position,
        imgWidth,
        imgHeight,
        undefined,
        "FAST"
      );
      heightLeft -= pageHeight;
    }
    doc.save(`quotation_${id}.pdf`);
  });
};

export const uploadPDF = (upload) => {
  const input = document.getElementById("divToPrint");
  html2canvas(input, { scale: "2" }).then((canvas) => {
    let imgData = canvas.toDataURL("image/jpeg", 0.3);
    let imgWidth = 210;
    let pageHeight = 300;
    let imgHeight = (canvas.height * imgWidth) / canvas.width;
    let heightLeft = imgHeight;
    let doc = new jsPDF({ format: "a4" });
    let position = 0;
    doc.addImage(
      imgData,
      "JPEG",
      0,
      position,
      imgWidth,
      imgHeight,
      undefined,
      "FAST"
    );
    heightLeft -= pageHeight;
    while (heightLeft >= 0) {
      position = heightLeft - imgHeight;
      doc.addPage();
      doc.addImage(
        imgData,
        "JPEG",
        0,
        position,
        imgWidth,
        imgHeight,
        undefined,
        "FAST"
      );
      heightLeft -= pageHeight;
    }
    doc = doc.output("blob");
    upload(doc);
  });
};

export const calcShipmentProperties = (shipment) => {
  shipment.actualweight =
    Math.round(
      parseFloat(shipment.weight) * parseFloat(shipment.quantity) * 10
    ) / 10;
    shipment.totalvolume =
      Math.round(
        ((parseFloat(shipment.height) *
          parseFloat(shipment['length']) *
          parseFloat(shipment.width)) /
          1000000) *
          parseFloat(shipment.quantity) *
          10
      ) / 10;
    shipment.chargeableweight =
      Math.round(
        ((parseFloat(shipment.height) *
          parseFloat(shipment['length']) *
          parseFloat(shipment.width)) /
          6000) *
          parseFloat(shipment.quantity) *
          10
      ) / 10;
  return shipment;
};
export const calcTotalShipmentWeightAndPcs = (shipments) => {
  let totalchargeableweight = 0;
  let totalactualweight = 0;
  let totalpieces = 0;
  let totalvolume = 0;
  shipments.forEach((shipment) => {
    totalchargeableweight += shipment.chargeableweight;
    totalactualweight += shipment.actualweight;
    totalvolume += shipment.totalvolume;
    if (shipment.quantity.length > 0) {
      totalpieces += parseFloat(shipment.quantity);
    }
  });
  return {
    shipmentweight: totalactualweight,
    shipmentchargeableweight:
      totalchargeableweight > totalactualweight
        ? totalchargeableweight
        : totalactualweight,
    shipmentpcs: totalpieces,
    shipmentvolume: totalvolume,
  };
};
